import React from "react";
import { PropTypes } from "prop-types";
import { connectWithLifecycle } from "react-lifecycle-component";
import { push } from "react-router-redux";
import { addVariation } from "../../redux/modules/ordersDuck";
import CancelOrderLineButton from "../container/CancelOrderLineButton";
import { ItemComponent } from "../presentational/Item";
import {
  getCurrentOrderTeamMap,
  getCurrentOrderCustomerMap,
  getCurrentOrderOrderLinesMap,
  getCurrentOrderLineMap,
  getCurrentOrderMap,
  getProductsMap
} from "../../redux/selectors";

const mapStateToProps = state => {
  return {
    customer: getCurrentOrderCustomerMap(state),
    currentOrder2: {
      team: getCurrentOrderTeamMap(state),
      orderLines: getCurrentOrderOrderLinesMap(state)
    },
    currentOrder: getCurrentOrderMap(state),
    currentOrderLine: getCurrentOrderLineMap(state),
    products: getProductsMap(state)
  };
};

const mapDispatchToProps = dispatch => ({
  handleVariationClick: (variation, currentOrder, currentOrderLine) => () => {
    const newVariation = variation.set(
      "fields",
      variation
        .get("fields")
        .map(
          field =>
            field.get("name") === "Equipo"
              ? field.set("value", currentOrder.getIn(["team", "id"]))
              : field
        )
    );
    dispatch(addVariation(newVariation));
    dispatch(
      push(
        `/order/${currentOrder.get("id")}/lines/${currentOrderLine.get(
          "id"
        )}/details`
      )
    );
  }
});

const ProductVariations = props => {
  const {
    currentOrder,
    currentOrderLine,
    products,
    handleVariationClick
  } = props;
  const orderLineProductId = currentOrderLine.getIn([
    "variation",
    "product",
    "id"
  ]);

  const product = products.find(
    product => product.get("id") === orderLineProductId
  );
  const variations = product.get("variations");
  const variationsToRender = variations
    .map(variation =>
      <ItemComponent
        key={variation.get("id")}
        image={variation.get("image")}
        text={`${variation.get("name")} (${variation.get("price")}€)`}
        handleProductClick={handleVariationClick(
          variation,
          currentOrder,
          currentOrderLine
        )}
      />
    )
    .toArray();
  return (
    <div>
      <h1>Variaciones</h1>
      <p>
        Escoge tipo de {product.get("name")}:
      </p>
      <div>
        {variationsToRender}
      </div>
      <CancelOrderLineButton />
    </div>
  );
};

ProductVariations.propTypes = {
  currentOrder: PropTypes.object.isRequired
  //products: PropTypes.array.isRequired,
};

const ProductVariationsPage = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(ProductVariations);

export default ProductVariationsPage;



// WEBPACK FOOTER //
// ./src/components/pages/Selling-Order-Variations.js